export const navigation = (() => {
    const toggleBtn = document.querySelectorAll("button[aria-controls='mainnav']");
    const header = document.getElementById("header");
    const mobSideNav = document.getElementById("js-sidenav-mobile");

    if (header) {
        if (header.querySelector('.siteMessage')) {
            header.classList.add("header--site-message");
        } else {
            header.classList.remove("header--site-message");
        }
    }

    toggleBtn[0].addEventListener("click", function () {
        header.classList.toggle("header--open");
        document.documentElement.classList.toggle("menu-open");
    });

    const mainNavButtons = document.querySelectorAll(".mainNav-button");
    Array.from(mainNavButtons).forEach((toggleBtn) => addEL(toggleBtn));

    function closeMega(navButton) {
        navButton.classList.remove("open");

        const action = navButton.querySelector(".mainNav-button--action");
        if (!action) return;

        const theId = action.getAttribute("aria-controls");
        Array.from(document.querySelectorAll(`[aria-controls="${theId}"]`)).forEach((b) => b.setAttribute("aria-expanded", "false"));

        const target = document.getElementById(theId);
        if (!target) return;

        target.setAttribute("aria-hidden", "true");
        target.classList.add("hidden");
    }

    function addEL(toggleBtn) {
        toggleBtn.addEventListener("click", function (event) {
            if (event.target.classList.contains("mainNav-button--action")) {
                event.preventDefault();
            }

            Array.from(mainNavButtons).forEach((b) => {
                if (b !== this) closeMega(b);
            });

            this.classList.toggle("open", this.querySelector(".mainNav-button--action")?.getAttribute("aria-expanded") === "true");
        });
    }

    Array.from(document.querySelectorAll(".mainNav-close")).forEach((closeBtn) => {
        closeBtn.addEventListener("click", function () {
            this.closest(".mainNav-listitem")?.querySelector(".mainNav-button")?.classList.remove("open");
        });
    });

    // Level 2 toggle functionality for mobile
    const lvl2Toggles = document.querySelectorAll(".mainNav-lvl2-toggle");

    Array.from(lvl2Toggles).forEach((toggleBtn) => {
        toggleBtn.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();

            const targetId = this.getAttribute("aria-controls");
            const targetEl = document.getElementById(targetId);

            if (!targetEl) {
                return;
            }

            const isExpanded = this.getAttribute("aria-expanded") === "true";

            // Toggle visibility
            this.setAttribute("aria-expanded", !isExpanded);
            targetEl.setAttribute("aria-hidden", isExpanded);

            // Explicitly add/remove hidden class based on state
            if (isExpanded) {
                targetEl.classList.add("hidden");
            } else {
                targetEl.classList.remove("hidden");
            }
        });
    });

    document.addEventListener("click", (e) => {
        if (!e.target.closest(".header-mainNav")) {
            Array.from(mainNavButtons).forEach(closeMega);
        }
    });

    if(mobSideNav) {
        let navHeader = document.getElementById('mobile-header');
        let side = document.querySelector('.employersGuide__side');
        let header = document.querySelector('header');
        let sideHeader = document.querySelector('.sideMenu-heading');

        mobSideNav.addEventListener("click", function (event) {

            event.preventDefault();
            side.classList.add('mob-open');
            header.classList.add('mob-close-bar');
            navHeader.innerText = event.target.innerText
            navHeader.classList.add('mobile-header--open');
            if(!sideHeader.classList.contains('sideMenu-heading--active')){
                sideHeader.click();   
            }
        });  
        
        navHeader.addEventListener("click", function () {
            side.classList.remove('mob-open');
            header.classList.remove('mob-close-bar');
            navHeader.classList.remove('mobile-header--open');
        });  
    }

})();
